import React from 'react'
import FormText from '../text/FormText'
import './form-number.scss'

/**
 * The props
 */
export interface FormNumberProps {
    /**
     * The value
     */
    value: number

    /**
     * The callback for when the value changes
     */
    onChange: (value: number) => void

    /**
     * The callback for when the input blurs out.
     */
    onBlur?: () => void

    /**
     * Max value
     */
    max?: number

    /**
     * Min value
     */
    min?: number
}

/**
 * The state
 */
export interface FormNumberState {
    /**
     * The form value of the number
     */
    value: string
}

/**
 * Modify a number value in a form.
 * 
 * @author Stan Hurks
 */
export default class FormNumber extends React.Component<FormNumberProps, FormNumberState> {

    constructor(props: FormNumberProps) {
        super(props)

        this.state = {
            value: String(props.value)
        }
    }

    public componentWillReceiveProps = () => {
        setTimeout(() => {
            this.setState({
                value: String(this.props.value)
            })
        })
    }

    public render = () => {
        return (
            <div className="form-number">
                <FormText
                    value={this.state.value}
                    onChange={(value) => {
                        if (value === '') {
                            this.setState({
                                value: ''
                            })
                            return
                        }

                        if (this.props.max !== undefined && Number(value) > this.props.max) {
                            this.setValue(this.props.max)
                            return
                        }

                        if (this.props.min !== undefined && Number(value) < this.props.min) {
                            this.setValue(this.props.min)
                            return
                        }

                        this.setValue(Number(value))
                    }}
                    onBlurWithEmptyString={() => {
                        this.setValue(this.props.min || 0)
                    }}
                    onBlur={() => {
                        if (this.props.onBlur) {
                            this.props.onBlur()
                        }
                    }}
                    isValid={new RegExp(/^([0-9]+)$|^$/g)} />
            </div>
        )
    }

    /**
     * Set the value
     * 
     * @param value the value
     */
    private setValue = (value: number) => {
        this.setState({
            value: String(value)
        }, () => {
            this.props.onChange(value)
        })
    }
}